<template>
  <div>
    <el-select
      :style="styles"
      v-model="val"
      filterable
      :multiple="multiple"
      :placeholder="placeholder"
      clearable
      @change="handlerChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
  import { getRoleList } from '@/api/public'
  import { transFormDataType } from '../utils'
  export default {
    name: 'ComRoleSelector',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择角色'
      },
      styles: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        val: undefined,
        options: []
      }
    },
    watch: {
      val: {
        handler(newVal, oldVal) {
          if (newVal === oldVal) {
            return
          }
          this.emitInput()
        }
      },
      value: {
        handler(newVal, oldVal) {
          if (newVal === this.val) {
            return
          }
          this.val = transFormDataType(newVal)
        },
        immediate: true
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        const { code, data } = await getRoleList()
        if (code !== 0) {
          return
        }
        if (!Array.isArray(data)) {
          return
        }
        data.forEach((it) => {
          it.label = it.name
          it.value = it.id + ''
        })
        this.options = data
      },
      emitInput() {
        const v = this.val
        this.$emit('input', v)
      },
      handlerChange(id) {
        if (this.multiple) {
          this.$emit('change', id)
          return
        }
        const item = this.options.find((item) => id === item.value)
        this.$emit('change', item)
      }
    }
  }
</script>

<style lang="scss" scoped></style>
